<template>
  <div class="px-6">
    <header class="mt-6 flex justify-between border-b-4 items-center">
          <h1 class="text-4xl">{{ formTitle }}</h1>
      </header>
      <form @submit.prevent="onFormSubmit">
          <div class="mt-6">
              <label class="mb-2 block uppercase text-xs text-teal-700 font-bold mr-8  w-48" for="order_number">Work Order Number</label>
              <input class="border rounded px-2 py-1" id="order_number" name="number" type="text" v-model="order.number" required :readonly="(existingOrder)"/>
          </div>

          <div class="mt-6">

              <label class="mb-2 block uppercase text-xs text-teal-700 font-bold mr-8  w-48" for="order_line">Line</label>
              <div class="relative">
                <select id="order_line" name="line" @change="onLineChange" v-model="selectedLine" required class="block appearance-none w-full bg-white border border-gray-300 text-gray-700 px-2 py-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                    <option value="">Select Line</option>
                    <option v-for="line in lines" :key="line.name" :value="line.name">{{ line.name }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
               </div>
              
          </div>

          <div class="mt-6">
              <label class="mb-2 block uppercase text-xs text-teal-700 font-bold mr-8  w-48" for="order_product">Product</label>
              <div class="relative">
                    <select id="order_product" name="product" @change="onProductChange" v-model="order.product" required class="block appearance-none w-full bg-white border border-gray-300 text-gray-700 px-2 py-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                        <option value="">Select Product</option>
                        <option v-for="product in products" :key="product.sku" :value="product.sku">{{product.sku }} - {{ product.description }}</option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
              </div>
              
              
          </div>

          <div class="mt-6">
              <label class="mb-2 block  uppercase text-xs text-teal-700 font-bold mr-8  w-48" for="order_amount">Units Ordered</label>
              <input  class="border rounded px-2 py-1" id="order_amount" name="amount_ordered" type="number" v-model="order.amount_ordered" required />
             
          </div>


          <div class="mt-6 z-20 relative">
              <label class="mb-2 block  uppercase text-xs text-teal-700 font-bold mr-8  w-48 flex-shrink-0" for="order_amount">Expected Start</label>
              <date-time-picker v-model="order.expected_start_date" :input-attributes="{required:true}" @change="onExpectedStartChange"></date-time-picker>
          </div>

          
          <div class="my-4 mt-8 border-t pt-4">
            <button type="submit" class='p-2 px-4 border rounded bg-orange-500 text-white mr-2'>{{ submitTitle }}</button>
            
            <button @click.prevent="onDelete" class='p-2 px-4 border rounded bg-red-500 text-white  mr-2'>Delete</button>
            <button @click.prevent="onCancel" class='p-2 px-4 border rounded mr-2'>Cancel</button>
          </div>

          <ul class="errors" v-if="errors">
              <li v-for="(error, index) in errors" :key="index">
                  {{ index }} : {{ error }}
              </li>

          </ul>
          

      </form>
  </div>
</template>

<script>
import DateTimePicker from "../components/DateTimePicker.vue"
import fecha from 'fecha'

export default {
    name: "build-order",
    components: {
        DateTimePicker
    },

    

    mounted: function(){

        //We always need to prefetch the lines
        this.getLines().then((lines)=>{
            if(this.$route.params.number){
                //we are modifying an existing record
                //Lets get the record for that number
                this.getExistingRecord(this.$route.params.number).then((record) => {
                    if(record){
                        this.getProducts();
                    }else{
                        console.log("Record not found");
                        this.$router.push({name: "orders"});
                    }
                })
            }else{
                //we are creating a new record. 
                //Just get the lines at mount. We will get anything else needed as we make selections.
            }
        })
        
    },

    data: function(){
        return {
            selectedLine: "",
            lines: [],
            products: [],
            order: {
                number: "",
                product: null,
                amount_ordered: 0,
                expected_start_date: this.getNow(),
                notes: ""
            },

            existingOrder: null,
            errors: null
        }
    },

    computed: {
        formTitle: function(){
            if(this.$route.params.number){
                return "Modify Work Order"
            }else{
                return "New Work Order"
            }
        },

        submitTitle: function(){
            if(this.$route.params.number){
                return "Update Order"
            }else{
                return "Submit Order"
            }
        }
    },

    methods: {

        getExistingRecord: async function(id){
            await this.$api.getRecord('workorders/'+id+'/').then((response) => {
                if(response.result){
                    if(response.result.product){
                        this.products = [response.result.product];
                        this.selectedLine = response.result.product.line;
                        response.result.product = response.result.product.sku;
                        
                    }
                    
                    
                    this.existingOrder = response.result;
                    this.order = { ...response.result };
                    
                }
            })
            .catch((error) => {
                console.log("Error");
                console.log(error);
            })

            return this.existingOrder;
        },

        

        getNow: function(){
            return fecha.format(new Date(), 'YYYY-MM-DDTHH:mm');
        },

        getEndOfDay: function(){

            let today = (new Date()).setHours(23, 59, 0);
            let endOfDay = (new Date(today));

            return fecha.format(endOfDay, 'YYYY-MM-DDTHH:mm');
        },

        onExpectedStartChange: function(){
            console.log("expected start change");
            // if(this.order.expected_completion_date){
            //     if(this.order.expected_completion_date < this.order.expected_start_date){
            //         this.order.expected_completion_date = this.order.expected_start_date;
            //     }
            // }
        },

        onCancel: function(){
            console.log("Cancel");
            this.leavePage();

        },

        onDelete: function(){
            console.log("Cancel");
            alert("This record can only be deleted from the admin portal.");
            return;
            
        },

        leavePage: function(){
            if(this.$route.params.number){
                this.$router.push({name: "order", params: { number: this.$route.params.number }});
            }else{
                this.$router.push({name: "orders"});
            }
        },

        onFormSubmit: function(){
            console.log("Form Submitted");

            if(this.$route.params.number){
                //this is an update (patch)

                var changes;
                Object.keys(this.order).forEach((key) => {
                    if(this.order[key] != this.existingOrder[key]){
                        if(!changes){
                            changes = {};
                        }
                        changes[key] = this.order[key];
                    }
                });

                if(changes){
                    this.$api.apiRequest("patch","workorders/"+this.$route.params.number+"/",changes).then((response) => {
                        console.log("patch response", response);
                        var errors = this.handleErrorsOrLeave(response);
                    })
                    .catch((error) => {
                        console.log("error", error, error.response);
                    })

                }else{
                    console.log("no changes detected, will just return to work order page");
                    alert("There were no changes made to this record. Make a change before updating or click Cancel to exit.")

                }



                
            }else{
                //this is a create (post)
                this.$api.apiRequest("post","workorders/",this.order).then((response) => {

                  

                    var errors = this.handleErrorsOrLeave(response);
                    console.log("post response", response);

                })
                .catch((error) => {
                    console.log("error", error, error.response);
                })

            }


            

        },

        onLineChange: function(){
            console.log("line changed");
            this.order.product = "";
            if(this.selectedLine){
                this.getProducts();
            }
        },

        onProductChange: function(){
            console.log("product changed");
            if(this.order.product){
                let product = this.products.find((record) => {
                    return (record.sku == this.order.product);
                })

                if(product){
                    this.order.amount_ordered = product.default_order_amount;
                    console.log("default order", product.default_order_amount);
                }
            }
        },

        getLines: async function(){
            await this.$api.getRecords("lines/").then((response) => {
                if(response.results){
                    this.lines = response.results;
                }
            })

            return this.lines;
        },

        getProducts: function(){

            var params;

            if(this.selectedLine){
                params = {
                    line: this.selectedLine
                }
            }

            this.$api.getRecords("products/", params).then((response) => {
                if(response.results){
                    this.products = response.results;
                }
            })
        },

        handleErrorsOrLeave: function(response){

            
            if(response.success && response.success.status < 300){
                this.leavePage();
            }else{
                let validationErrors = this.checkForValidationErrors(response);

                if(validationErrors ){
                    alert("There was a problem. Check the form and try again.");
                }
            }
        },

        checkForValidationErrors: function(response){
            console.log("Checking for errors");
            if(response.error){
                console.log("Error found");
                if(response.error.response){
                    let errorResponse = response.error.response;
                    if(errorResponse.data){
                        console.log("Validation Errors", errorResponse.data);
                        this.errors = errorResponse.data;
                        return this.errors;
                    }
                }
            }
        }
    }
}
</script>

<style>



</style>